// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b53c6c32","74":"4b7b0ceb","453":"6ff05604","709":"9a780df7","732":"38aaf363","785":"631b426f","970":"5a644939"}[chunkId] + ".chunk.js";
};